const countryCodes = [
  { code: "NE", name: "Niger", flag: "🇳🇪", dial: "+227" },
  { code: "DZ", name: "Algérie", flag: "🇩🇿", dial: "+213" },
  { code: "BJ", name: "Bénin", flag: "🇧🇯", dial: "+229" },
  { code: "BF", name: "Burkina Faso", flag: "🇧🇫", dial: "+226" },
  { code: "CM", name: "Cameroun", flag: "🇨🇲", dial: "+237" },
  { code: "CI", name: "Côte d'Ivoire", flag: "🇨🇮", dial: "+225" },
  { code: "US", name: "États-Unis", flag: "🇺🇸", dial: "+1" },
  { code: "FR", name: "France", flag: "🇫🇷", dial: "+33" },
  { code: "GH", name: "Ghana", flag: "🇬🇭", dial: "+233" },
  { code: "GN", name: "Guinée", flag: "🇬🇳", dial: "+224" },
  { code: "ML", name: "Mali", flag: "🇲🇱", dial: "+223" },
  { code: "MA", name: "Maroc", flag: "🇲🇦", dial: "+212" },
  { code: "NG", name: "Nigeria", flag: "🇳🇬", dial: "+234" },
  { code: "SN", name: "Sénégal", flag: "🇸🇳", dial: "+221" },
  { code: "TD", name: "Tchad", flag: "🇹🇩", dial: "+235" },
  { code: "TG", name: "Togo", flag: "🇹🇬", dial: "+228" },
];

export default countryCodes;
